import { mapParamsBySchema } from '../../../../util';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { M_TBM_CUSTOM_01_Schema } from './M_TBM_CUSTOM_01_Schema';
import useDeleteMutation from '../../../../Hooks/apis/useDeleteMutaion';

/** TBM 참석 취소 SP_TBM_MEMBER_D2 */
export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (item) => {
    const payload = mapParamsBySchema(M_TBM_CUSTOM_01_Schema.mapper.delete1, item);
    return apiRequest('post', Global.urls.TBM.deleteTbmD2, payload);
  }, options);
};
